export default __webpack_public_path__ + "static/media/guide_main.090869ec.png";